/* taaralu-cart-fast.js
   Makes Add to Cart respond in 1-2 seconds by stripping section rendering
   from the theme's own /cart/add.js call — no double-add, no interception.
   Toast fires on the theme's cart:update event (which is now fast).
*/
(function () {
  'use strict';

  /* ── STRIP SECTIONS BEFORE THEME'S HANDLER RUNS ────────────
     The theme appends data-section-id values to FormData so Shopify
     renders cart HTML server-side in the same request — this is what
     takes 5-30 seconds when any app injects slow Liquid into cart sections.
     We temporarily remove those ids so the theme's request is a fast
     JSON-only call, then restore them immediately after.
  ──────────────────────────────────────────────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;

    /* Collect and clear all data-section-id values */
    var stripped = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      stripped.push({ el: el, id: el.getAttribute('data-section-id') });
      el.removeAttribute('data-section-id');
    });

    /* Restore after the theme's handler has read the FormData (next tick) */
    if (stripped.length) {
      setTimeout(function () {
        stripped.forEach(function (item) {
          item.el.setAttribute('data-section-id', item.id);
        });
      }, 0);
    }

    /* Do NOT call preventDefault or stopPropagation —
       let the theme handle the actual add, just without sections. */
  }, true /* capture: fires before theme's bubble-phase handler */);


  /* ── TOAST NOTIFICATION ─────────────────────────────────── */
  var toastTimer;

  function showToast(msg, isError) {
    var el = document.getElementById('taaralu-atc-toast');
    if (el) { clearTimeout(toastTimer); el.remove(); }

    el = document.createElement('div');
    el.id = 'taaralu-atc-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.textContent = msg;
    if (isError) el.classList.add('taaralu-atc-toast--error');
    document.body.appendChild(el);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('taaralu-atc-toast--visible'); });
    });

    toastTimer = setTimeout(function () {
      el.classList.remove('taaralu-atc-toast--visible');
      setTimeout(function () { if (el.parentNode) el.remove(); }, 400);
    }, 3000);
  }

  /* ── LISTEN FOR THEME'S CART EVENTS ────────────────────────
     The theme dispatches cart:update after its /cart/add.js call succeeds.
     With sections stripped, this fires within ~1 second.
  ──────────────────────────────────────────────────────────── */
  document.addEventListener('cart:update', function (e) {
    var detail = e && e.detail;
    if (!detail || !detail.data) return;
    if (detail.data.source !== 'product-form-component') return;
    if (detail.data.didError) return;
    showToast('✓  Added to cart!');
  });

  document.addEventListener('cart:error', function (e) {
    var msg = (e && e.detail && e.detail.data && e.detail.data.message) || 'Could not add to cart.';
    showToast(msg, true);
  });

})();
